import React, { useState, useContext, useEffect } from 'react';
// import MaterialTable from "material-table";
import { useDispatch, useSelector } from 'react-redux';
// import { tableIcons } from "../../../../../components/TableIcons";
import { Form, Formik } from 'formik';
import {
  FormHelperText,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  TablePagination,
} from '@material-ui/core';
import { ThemeContext } from '../../../../themes/ThemeProvider';
import {
  postWorkFilterTest,
  testFilterResetData,
  resetMessage,
  postTestFilterRuleGroup,
} from '../../../../redux/reducers/WorkQueueSetup/index';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, Button, FormControlLabel } from '@material-ui/core';
import * as Yup from 'yup';
import { defaultRows } from '../../../../constants/ReusableTablePagination';
import { tablePageRows } from '../../../../constants/ReusableConstants';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import PageLoader from '../../../../components/PageLoader';
import { tableIcons } from '../../../../components/TableIcons';
import { isTimestamp, convertTimestampToDate } from '../../../../util/Time';

const useStyles = makeStyles({
  input: {
    '& .MuiInputBase-formControl': {
      minHeight: '50px !important',
    },
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  border: {
    border: '1px solid #333',
    margin: '0px 8px',
    padding: '4px',
    borderRadius: '5px',
  },
  label: {
    color: 'white',
    padding: '3px',
  },
  radioGroup: {
    border: '1px solid gray',
  },
});
function TestComponent({ testRows, testColumns, passValuesTest, isWorkQueueTest }) {
  const { basicInfoData, isLoading, errorMsg, testFilterResponse } = useSelector(
    ({ addWorkQueue }) => addWorkQueue,
  );
  const { reusableInputStyles } = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const useclasses = useStyles();
  const [rows, setRows] = useState(defaultRows);
  const [page, setPage] = useState(0);
  const [filterRuleGroup, setFilterRuleGroup] = useState({});
  const columns = [
    {
      title: 'Result',
      field: 'result',
      minWidth: '100px',
      render: (rowData) => {
        return rowData?.result;
      },
    },
    {
      title: 'Account Number',
      field: 'ACCOUNT_NUMBER',
      minWidth: '100px',
      render: (rowData) => {
        return rowData?.account_number;
      },
    },
    {
      title: 'Fields',
      minWidth: '550px',
      render: (rowData) => {
        const fieldsResult = [];
        for (const [key, value] of Object.entries(rowData)) {
          if (
            key === 'dbacct' ||
            key === 'tableData' ||
            key === 'result' ||
            key === 'account_number'
          ) {
            continue;
          }

          if (isTimestamp(value)) {
            const formattedValue = convertTimestampToDate(value);
            fieldsResult.push({
              key: key,
              value: formattedValue,
            });

            continue;
          }

          fieldsResult.push({
            key: key,
            value: value,
          });
        }
        return (
          <div>
            {fieldsResult.map((each, index) => {
              return (
                <span className={useclasses.border} key={index}>
                  {`${each.key} = ${each.value} `}{' '}
                </span>
              );
            })}
          </div>
        );
      },
    },
  ];
  const rows1 = testFilterResponse?.result?.map((each) => {
    return {
      ...each,
      tableData: { checked: true },
    };
  });

  const initialValues = {
    startAccountNo: '',
    evaluateAccountsType: 'True',
  };
  const schema = Yup.object().shape({
    startAccountNo: Yup.number().required('Starting Account Number is required'),
  });
  useEffect(() => {
    if (testFilterResponse) {
      dispatch(testFilterResetData());
    }
  }, []);

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 5000);
    }
  }, [errorMsg]);

  const isOutputValues = ['True', 'All'];
  const handleSubmit = (values) => {
    if (passValuesTest) {
      const payload = {
        isEvaluateFalse: values.evaluateAccountsType === 'True' ? 'N' : 'Y',
        isEvaluateTrue: values.evaluateAccountsType === 'False' ? 'N' : 'Y',
        limit: 15,
        page: 1,
        workqueueId: basicInfoData?.workqueueId ? basicInfoData?.workqueueId : 0,
        workqueueName: basicInfoData?.workqueueName ? basicInfoData?.workqueueName : '',
        workqueueRules:
          passValuesTest?.sqlRules?.length > 0
            ? passValuesTest?.sqlRules?.map((item, i) => {
              return {
                fieldName: item?.fieldName,
                fieldType: item?.fieldType
                  ? item?.fieldType?.toLowerCase()
                  : item?.dataType?.toLowerCase(),
                filterCondition: item?.filterCondition,
                repository: item?.repositoryName,
                ruleCode: item?.ruleCode,
                sqlExpression: item?.sqlExpression,
                value: item?.value,
                value1: item?.value1,
                reportRulesId: item?.workqueueRuleId ? item?.workqueueRuleId : 0,
              };
            })
            : [],
        result: passValuesTest?.result,
        sqlRules: passValuesTest.sqlRules.map((each) => {
          return {
            groupCode: '',
            ruleCode: each?.ruleCode,
            sqlCode: each?.sqlExpression,
            id: each?.reportRulesId,
            field: each?.fieldName ? each?.fieldName : '',
            repository: each?.repositoryName ? each?.repositoryName : '',
          };
        }),
        startAccountNo: values.startAccountNo,
      };
      setFilterRuleGroup(payload);

      dispatch(postWorkFilterTest(payload));
    } else {
      const testValues = {
        fieldListCode: passValuesTest.fieldListCode,
        result: passValuesTest.result,
        isEvaluateTrue:
          values.evaluateAccountsType === 'All' || values.evaluateAccountsType === 'True'
            ? 'Y'
            : 'N',
        isEvaluateFalse:
          values.evaluateAccountsType === 'All' || values.evaluateAccountsType === 'False'
            ? 'Y'
            : 'N',
        startAccountNo: values.startAccountNo,
        sqlRules: passValuesTest.sqlRules,
        limit: 15,
        page: 1,
      };
      setFilterRuleGroup(testValues);

      dispatch(postTestFilterRuleGroup(testValues));
    }
    setPage(0);
    setRows(15);
  };

  return (
    <div className="col">
      <div>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          validationSchema={schema}
          // enableReinitialize
        >
          {(props) => {
            const { values, handleChange, handleReset, handleBlur, errors, touched } = props;
            return (
              <Form autoComplete="off" noValidate>
                <div className="form-row global-field-textfields new-standard-textfields">
                  <div className="col-md-6 col-lg-4 form-group">
                    <div className="test-radio-group">
                      <FormLabel
                        component="legend"
                        className={`${classes.radioGroup}  radio-label `}
                      >
                        Display Accounts that Assess
                      </FormLabel>
                      <RadioGroup
                        row
                        name="evaluateAccountsType"
                        id="evaluateAccountsType"
                        defaultValue="All"
                        value={values?.evaluateAccountsType}
                      >
                        {isOutputValues.map((item, i) => (
                          <FormControlLabel
                            key={i}
                            value={item}
                            control={
                              <Radio
                                name="evaluateAccountsType"
                                // checked={values?.evaluateAccountsType === "All"}
                                onChange={handleChange}
                                // onChange={(val) => {
                                //   setFieldValue((values.evaluateAccountsType = item));
                                // }}
                              />
                            }
                            label={item}
                          />
                        ))}
                      </RadioGroup>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4 form-group">
                    <TextField
                      className={` ${classes.labelName}`}
                      margin="dense"
                      variant="outlined"
                      placeholder={`Enter Starting Account Number`}
                      label="Starting Account Number"
                      type="number"
                      // className={`${useclasses.input} ${classes.labelName} ${classes.inputLabel}`}
                      name="startAccountNo"
                      value={values.startAccountNo}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      required
                      error={Boolean(errors.startAccountNo && touched.startAccountNo)}
                    />
                    <FormHelperText style={{ color: 'red' }}>
                      {touched.startAccountNo && errors.startAccountNo && errors.startAccountNo}
                    </FormHelperText>
                  </div>
                  <div className="col-md-12 col-lg-4 form-group">
                    <div className="d-flex justify-content-md-center justify-content-lg-start">
                      <Button
                        variant="outlined"
                        className={`reset-btn mx-1 ${classes.buttonRoot}`}
                        onClick={() => {
                          handleReset();
                          dispatch(testFilterResetData());
                        }}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="outlined"
                        type="submit"
                        className={`search-btn mx-1 ${classes.buttonRoot}`}
                      >
                        Run Test
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
      <Grid item xs={12} className="">
        <div className="custom-table global-field-table new-standard-textfields">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={rows1 ? rows1 : []}
            options={{
              toolbar: false,
              search: false,
              pageSize: rows,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
            }}
            onChangeRowsPerPage={(event) => {
              setRows(event);
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: { 'aria-label': 'Rows per screen' },
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    emptyRowsWhenPaging={false}
                    count={testFilterResponse?.count ? testFilterResponse?.count : 0}
                    rowsPerPageOptions={tablePageRows}
                    rowsPerPage={rows}
                    page={page}
                    onChangePage={(e, pageNumber) => {
                      setPage(pageNumber);
                      if (passValuesTest?.isWorkFilter) {
                        dispatch(
                          postWorkFilterTest({
                            ...filterRuleGroup,
                            page: pageNumber + 1,
                            limit: rows,
                          }),
                        );
                      } else {
                        dispatch(
                          postTestFilterRuleGroup({
                            ...filterRuleGroup,
                            page: pageNumber + 1,
                            limit: rows,
                          }),
                        );
                      }
                    }}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                      setPage(0);
                      if (passValuesTest?.isWorkFilter) {
                        dispatch(
                          postWorkFilterTest({
                            ...filterRuleGroup,
                            page: 1,
                            limit: event.target.value,
                          }),
                        );
                      } else {
                        dispatch(
                          postTestFilterRuleGroup({
                            ...filterRuleGroup,
                            page: 1,
                            limit: event.target.value,
                          }),
                        );
                      }
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      </Grid>
      {isLoading && isWorkQueueTest && <PageLoader />}
    </div>
  );
}
export default TestComponent;
